import type { CardDirection, FlowThemeCardMotion } from '../../cardMotion';

/**
 * The card goes with the leaf: it lifts off along the spine and fades as the page turns, and the next
 * card settles onto the fresh page a beat later (going back runs the same motion the other way).
 */
export const lifePlanCardMotion = (): FlowThemeCardMotion => ({
  variants: {
    enter: (direction: CardDirection) => ({ opacity: 0, x: direction > 0 ? 46 : -46, rotateY: direction > 0 ? 16 : -16, scale: 0.985 }),
    center: { opacity: 1, x: 0, rotateY: 0, scale: 1, transition: { duration: 0.62, delay: 0.28, ease: [0.22, 1, 0.36, 1] } },
    exit: (direction: CardDirection) => ({ opacity: 0, x: direction > 0 ? -110 : 110, rotateY: direction > 0 ? -34 : 34, scale: 0.985, transition: { duration: 0.42, ease: [0.4, 0, 0.9, 0.6] } }),
  },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  style: { transformPerspective: 1500 },
});
